import { IGalleryAlbum } from '../../gallery-interfaces';
import DragAlbumItemTarget from './drag/drag-album-item-target';
import DragAlbumTarget from './drag/drag-album-target';
import GalleryMenuItemTitle from './gallery-menu-item-title';

interface IGalleryMenuItemProps {
    album: IGalleryAlbum;
    isLast?: boolean;
}

const GalleryMenuItem = ({ album, isLast } : IGalleryMenuItemProps) => {

    const hasNestedItems = album?.nested.length > 0;

    return (
        <div className={ `gallery__menu-item flex flex-col flex-1 ${ isLast ? '' : 'pb-2' }` }>

            <GalleryMenuItemTitle album={ album } />

            <DragAlbumItemTarget
                album_id={ album.album_id }
            />

            <DragAlbumTarget parent_album_id={ album.album_id } />

            {
                hasNestedItems && album.isOpened &&
                <div className="ml-3 mt-2 border-l border-slate-700">
                    {
                        album.nested.map((nestedAlbum, index) => {
                            return (
                                <GalleryMenuItem
                                    key={ nestedAlbum.album_id }
                                    album={ nestedAlbum }
                                    isLast={ index === album.nested.length - 1 }
                                />
                            )
                        })
                    }
                </div>
            }

        </div>
    )
};

export default GalleryMenuItem;